import { useState } from "react";

export const useMiMenuController = ({
  disabled = false,
  onMenuOpen = () => {},
  closeContextMenu = () => {},
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = (event) => {
    event.stopPropagation();
    if (disabled) {
      return;
    }
    setAnchorEl(event.currentTarget);
    onMenuOpen();
  };

  const closeMenu = (e) => {
    e?.stopPropagation();
    setAnchorEl(null);
    closeContextMenu();
  };

  const handleAction = (event, item) => {
    event.stopPropagation();
    item.action(event, item);

    if (item.keepMenuOpen) {
      return;
    }

    closeMenu();
  };

  return { anchorEl, openMenu, closeMenu, handleAction };
};
